import React from 'react';
import styles from './GstOverview.module.scss';
import { GstOverviewSummary } from '../../../../store/dashboard/gstOverview/types';

interface KpiStripProps {
    summary: GstOverviewSummary;
}

function KpiStrip({ summary }: Readonly<KpiStripProps>) {
    return (
        <div className={styles.KpiStrip}>
            <div className={styles.KpiCard}>
                <div className={styles.KpiCardHeader}>
                    <span className={styles.KpiTitle}>Total GSTIN</span>
                    <span className={styles.KpiTotalPill}>{summary.totalGstinCount} Total</span>
                </div>
                <div className={styles.KpiBigValue}>
                    {summary.activeGstinCount}
                    <span className={styles.KpiBigValueSuffix}>Active</span>
                </div>
            </div>
            <div className={styles.KpiCard}>
                <div className={styles.KpiCardHeader}>
                    <span className={styles.KpiTitle}>HSN &amp; SAC Active</span>
                </div>
                <div className={styles.KpiBigValue}>{summary.hsnSacActiveCount}</div>
            </div>
        </div>
    );
}

export default KpiStrip;
